import { Component, input, output } from '@angular/core';
import { RidAudioButton } from '../rid-audio-button/rid-audio-button';
import { RidCorrectAnswerModal } from '../rid-correct-answer-modal/rid-correct-answer-modal';
import { RidKlankvoetRuleGlyph } from '../rid-klankvoet-rule-glyph/rid-klankvoet-rule-glyph';

export type TKlankvoetRule = 'SPLIT_AFTER_MULTITEKEN_KLANK' | 'SPLIT_BEFORE_CENTRAL_CONSONANT' | 'SPLIT_BETWEEN_CONSONANTS';

@Component({
  selector: 'rid-klankvoet-rule-modal',
  imports: [RidCorrectAnswerModal, RidAudioButton, RidKlankvoetRuleGlyph],
  templateUrl: './rid-klankvoet-rule-modal.html',
  host: {
    class: 'contents',
  },
})
export class RidKlankvoetRuleModal {
  rule = input.required<TKlankvoetRule>();

  continue = output<void>();
}
